import React, { useState, useEffect } from 'react';
import './PrivacyPolicy.css';
import logo from '../tagrrlogo.jpeg';

const PrivacyPolicy = () => {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPrivacyPolicies = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Determine API URL based on environment
        // In production, use relative path (nginx proxy)
        // In development, use full URL
        const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const apiUrl = isDevelopment 
          ? 'http://localhost:8080/api/settings/privacy-policies/public'
          : '/api/settings/privacy-policies/public';
        
        // Use the public endpoint - no authentication required
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch privacy policies: ${response.status}`);
        }

        const result = await response.json();

        if (result.success && result.data && result.data.policies) {
          setPolicies(result.data.policies);
        } else {
          setPolicies([]);
        }
      } catch (err) {
        console.error('Error fetching privacy policies:', err);
        setError('حدث خطأ أثناء جلب سياسات الخصوصية. يرجى المحاولة مرة أخرى.');
        setPolicies([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPrivacyPolicies();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('ar-SA', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="privacy-policy-page">
        <div className="privacy-policy-container">
          <div className="loading-state">
            <p>جاري التحميل...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="privacy-policy-page">
        <div className="privacy-policy-container">
          <div className="error-state">
            <p>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="privacy-policy-page">
      <div className="privacy-policy-container">
        <header className="privacy-policy-header">
          <div className="header-top">
            <div className="header-logo">
              <img src={logo} alt="تحرر Logo" />
            </div>
            <div className="header-brand">
              <h1>سياسة الخصوصية</h1>
              <p className="subtitle">Privacy Policy</p>
            </div>
            <div className="header-title">
              <span>تحرر</span>
            </div>
          </div>
        </header>

        {policies.length === 0 ? (
          <div className="empty-state">
            <p>لا توجد سياسات خصوصية متاحة حالياً</p>
          </div>
        ) : (
          <div className="privacy-policy-content">
            {policies.map((policy, index) => (
              <article key={policy._id || index} className="policy-section">
                <h2>{policy.title}</h2>
                {policy.updatedAt && (
                  <p className="policy-date">
                    آخر تحديث: {formatDate(policy.updatedAt)}
                  </p>
                )}
                <div 
                  className="policy-text"
                  dangerouslySetInnerHTML={{ 
                    __html: policy.content.replace(/\n/g, '<br />')
                  }}
                />
              </article>
            ))}
          </div>
        )}

        <footer className="privacy-policy-footer">
          <div className="footer-wrapper">
            <div className="footer-main">
              <div className="footer-left">
                <div className="footer-logo-section">
                  <img src={logo} alt="تحرر Logo" className="footer-logo-img" />
                  <span className="footer-brand-name">تحرر</span>
                </div>
              </div>
              <div className="footer-right">
                <div className="footer-section">
                  <h3 className="footer-section-title">معلومات التواصل</h3>
                  <a href="mailto:Tahrrapp@gmail.com" className="footer-email">
                    <svg className="email-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                    Tahrrapp@gmail.com
                  </a>
                </div>
                <div className="footer-section">
                  <h3 className="footer-section-title">الترخيص</h3>
                  <p className="footer-license">
                    تطبيق تحرر مرخص من وزارة التجارة والمركز السعودي للأعمال ووزارة الصحة
                  </p>
                </div>
              </div>
            </div>
            <div className="footer-bottom">
              <p className="footer-copyright">© تحرر 2025. جميع الحقوق محفوظة</p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

